module.exports = __webpack_public_path__ + "static/P2101493-651626625137cafa0bb0c4936fbd1c3b.jpg";